import { InjectionToken } from '@angular/core';

/** Diferencia, em serviços root compartilhados, se a instância ativa roda dentro do leaf chrome-less. */
export const RUNNING_IN_LEAF_HOST = new InjectionToken<boolean>('RUNNING_IN_LEAF_HOST');
